import { createContext } from 'react';

export interface BusinessPlanProgressContextProps {
  completedSteps: string[];
  setCompletedSteps: (v: string[]) => void;
  currentStep: string;
  setCurrentStep: (v: string) => void;
  // New methods for plan-specific state management
  getCompletedStepsForPlan: (planId: string) => string[];
  setCompletedStepsForPlan: (planId: string, steps: string[]) => void;
  clearPlanProgress: (planId: string) => void;
  // Total steps count for progress calculation
  totalStepsCount?: number;
  setTotalStepsCount: (count: number) => void;
}

export const BusinessPlanProgressContext = createContext<
  BusinessPlanProgressContextProps | undefined
>(undefined);
